var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSieIntranetBlackRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Intranet_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 16",
    style: {
      enableBackground: "new 0 0 45 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    d: "M45,16H0V0h45V16z M1,15h43V1H1V15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "INTRA",
    d: "M7,12.3V4H6v8.3H7z M10.8,12.3V6.9c0-0.6,0-1.2,0-1.6c0.3,0.6,0.6,1.1,0.9,1.6l0,0l3.2,5.3H16V4h-0.9v5.7 c0,0.5,0,0.9,0,1.2l0,0l-0.2-0.3c-0.3-0.5-0.5-1-0.8-1.3l0,0L11,4H9.9v8.3H10.8z M21.4,12.3V4.8h2.5V4H18v0.8h2.4v7.5H21.4z  M26.8,12.3V8.6h0.3c0.4,0,0.6,0,0.8,0.1s0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.4,0.4s0.2,0.5,0.4,0.9l0,0l0.9,2.1h1l-1-2.5 c-0.2-0.6-0.4-0.9-0.6-1.1s-0.4-0.3-0.7-0.4c0.6-0.1,1-0.4,1.3-0.7s0.5-0.8,0.5-1.4c0-0.8-0.3-1.4-1-1.8c-0.4-0.2-1.1-0.4-2-0.4l0,0 h-1.8v8.3H26.8z M27.2,7.8h-0.4v-3h0.6c0.7,0,1.2,0.1,1.5,0.2c0.4,0.2,0.7,0.6,0.7,1.2c0,0.6-0.3,1.1-0.8,1.3 C28.4,7.7,27.9,7.8,27.2,7.8L27.2,7.8z M33.1,12.3l1-2.9h3.1l1,2.9h1l-3-8.3h-1.2l-3,8.3H33.1z M36.9,8.6h-2.5l0.8-2.2 c0.2-0.6,0.4-1.1,0.5-1.6c0.2,0.5,0.3,1,0.5,1.6l0,0L36.9,8.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSieIntranetBlackRgb);
export default __webpack_public_path__ + "static/media/sie-intranet-black-rgb.99377b0b5d12ac4f0c9a9df418056d8a.svg";
export { ForwardRef as ReactComponent };